export const HAS_NOT_SEEN_NEW_SUBJECT_MODAL = 'has_not_seen_functional_literacy_modal';

export interface PropsWithPathname {
    pathname: string;
}
